var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIconActiveDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.950195,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_642_8251)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.2239C17 16.517 18.8261 15.4317 20.3254 16.2475L32.687 22.9737C34.2531 23.8258 34.2531 26.0742 32.687 26.9264L20.3254 33.6526C18.8261 34.4683 17 33.383 17 31.6762V18.2239Z",
    fill: "#1F2130"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_642_8251",
    x1: 24,
    y1: 0.950195,
    x2: 24,
    y2: 48.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8957CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconActiveDark);
export default __webpack_public_path__ + "static/media/playIconActiveDark.1f368bc873e989e93dd36fa254ef58dd.svg";
export { ForwardRef as ReactComponent };